import React from 'react';
import { motion } from 'framer-motion';

export default function FederationMap() {
  const nodes = [
    { id: 'roger', name: 'Roger', x: 50, y: 10, tier: 1, color: '#00F0FF' },
    { id: 'rex', name: 'Rex', x: 30, y: 30, tier: 1, color: '#00F0FF' },
    { id: 'agent-zero', name: 'Agent Zero', x: 70, y: 30, tier: 1, color: '#FF0000' },
    { id: 'oracle', name: 'Oracle', x: 50, y: 50, tier: 1, color: '#00F0FF' },
    { id: 'roger-ai', name: 'Roger AI', x: 20, y: 50, tier: 1, color: '#00F0FF' },
    { id: 'aria', name: 'Aria', x: 15, y: 70, tier: 2, color: '#FF00FF' },
    { id: 'xavier', name: 'Xavier', x: 35, y: 70, tier: 1, color: '#00FFA3' },
    { id: 'axiom', name: 'Axiom', x: 50, y: 75, tier: 2, color: '#FFB800' },
    { id: 'geminus', name: 'Geminus', x: 65, y: 70, tier: 2, color: '#00D9E8' },
    { id: 'catalyst', name: 'Catalyst', x: 85, y: 70, tier: 2, color: '#E040FB' },
    { id: 'keys', name: 'KEYS', x: 80, y: 50, tier: 2, color: '#9C27B0' },
    { id: 'recycler', name: 'Recycler', x: 25, y: 90, tier: 2, color: '#FF6B6B' },
    { id: 'echo', name: 'Echo', x: 75, y: 90, tier: 2, color: '#4FC3F7' }
  ];

  const connections = [
    { from: 'roger', to: 'rex' },
    { from: 'roger', to: 'agent-zero' },
    { from: 'rex', to: 'oracle' },
    { from: 'agent-zero', to: 'oracle' },
    { from: 'oracle', to: 'roger-ai' },
    { from: 'oracle', to: 'keys' },
    { from: 'roger-ai', to: 'aria' },
    { from: 'roger-ai', to: 'xavier' },
    { from: 'oracle', to: 'axiom' },
    { from: 'axiom', to: 'geminus' },
    { from: 'keys', to: 'catalyst' },
    { from: 'aria', to: 'recycler' },
    { from: 'catalyst', to: 'echo' }
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      className="max-w-6xl mx-auto mb-20"
    >
      <h2 className="text-3xl font-unbounded font-black text-white mb-8 text-center">
        Federation Network Topology
      </h2>

      <div className="glass-panel p-8">
        <svg 
          viewBox="0 0 100 100" 
          className="w-full h-auto"
          style={{ minHeight: '500px' }}
        >
          {/* Connections */}
          {connections.map((conn, idx) => {
            const fromNode = nodes.find(n => n.id === conn.from);
            const toNode = nodes.find(n => n.id === conn.to);
            return (
              <motion.line
                key={`${conn.from}-${conn.to}`}
                x1={fromNode.x}
                y1={fromNode.y}
                x2={toNode.x}
                y2={toNode.y}
                stroke="rgba(0,240,255,0.2)"
                strokeWidth="0.3"
                initial={{ pathLength: 0, opacity: 0 }}
                animate={{ pathLength: 1, opacity: 1 }}
                transition={{ duration: 1, delay: idx * 0.05 }}
              />
            );
          })}

          {/* Nodes */}
          {nodes.map((node, idx) => (
            <g key={node.id}>
              {/* Node glow */}
              <motion.circle
                cx={node.x}
                cy={node.y}
                r="3"
                fill={node.color}
                opacity="0.3"
                initial={{ scale: 0 }}
                animate={{ scale: [1, 1.2, 1] }}
                transition={{ 
                  duration: 2, 
                  repeat: Infinity, 
                  delay: idx * 0.1 
                }}
              />
              
              {/* Node core */}
              <motion.circle
                cx={node.x}
                cy={node.y}
                r="1.5"
                fill={node.color}
                stroke="#fff"
                strokeWidth="0.3"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ duration: 0.5, delay: idx * 0.05 }}
              />

              {/* Label */}
              <text
                x={node.x}
                y={node.y - 3}
                textAnchor="middle"
                fill="#fff"
                fontSize="2.5"
                fontWeight="bold"
                style={{ 
                  fontFamily: 'Unbounded, sans-serif',
                  textShadow: '0 0 4px rgba(0,0,0,0.8)'
                }}
              >
                {node.name}
              </text>
            </g>
          ))}
        </svg>

        <div className="mt-6 text-center text-gray-400 text-sm">
          <p className="mb-2">
            <span className="inline-block w-3 h-3 rounded-full bg-cyan-400 mr-2"></span>
            Tier 1: Minds (High-fidelity photos)
          </p>
          <p>
            <span className="inline-block w-3 h-3 rounded-full bg-purple-400 mr-2"></span>
            Tier 2: Hands (Winged bot illustrations)
          </p>
        </div>
      </div>
    </motion.div>
  );
}
